// moz667: por culpa de vrdemo
var $ = jQuery;

// Imagenes modales
$(".modal-image").each(function () {
    var $link = $(this);

    var message = "";

    var img_src = $link.attr("href");

    message = '<img class="img-fluid" src="' + img_src + '" />';

    $link.off("click").on("click", function (e) {
        e.preventDefault();

        alertDialog.show({
            title: $link.attr("title"),
            dialogSize: "xl",
            message: message
        });
    });
});
